module.exports = function getResource(label) {
    let resources = {
        sortBy: 'Sort by'
    };

    return resources[label];
};
